import React, { Fragment } from 'react'
import { getSupersubeingColor,getSuperheadeingColor,getSubeingColor, convertTimeStampToDate } from './Reports.js';
import { indexOf } from 'lodash';
import "./Reports.css";

function DQI_Detailed({ dqi_params, thresholdColorsDqi }) {
 

  const getDQIColor = (value) => {
    const matchingColor = thresholdColorsDqi?.find(colors => value <= parseInt(colors.maxThresholdValue));
  
    if (matchingColor) {
        return { backgroundColor: matchingColor.backgroundColor, color: matchingColor.color };
    }
};

  if (dqi_params.data.businessUnit) {
    let totalLogs = 0;
    const indexLabels = ['Start Index', 'End Index'];

    // Calculate the total number of logs
    dqi_params.data.businessUnit.forEach(provider => {
      provider.rigs.forEach(rig => {
        rig.wells.forEach(well => {
          totalLogs += well.logs.length;
        });
      });
    });

    const truncateText = (text) => {
      if (text && text.includes('(')) {
          const openingBracketIndex = text.indexOf('(');
          const truncatedText = text.substring(0, openingBracketIndex) + '\n' + text.substring(openingBracketIndex);
          return truncatedText;
      }
      return text;
    };

    const filteredBusinessUnit = dqi_params.data.businessUnit
    .map(unit => ({
        ...unit,
        rigs: unit.rigs
            .map(rig => ({
                ...rig,
                wells: rig.wells.filter(well => well.logs.length > 0)
            }))
            .filter(rig => rig.wells.length > 0)
    }))
    .filter(unit => unit.rigs.length > 0);


  const totalProviderLogsforAll = filteredBusinessUnit.reduce((accProvider, provider) => {
    return accProvider + provider.rigs.reduce((accRig, rig) => {
      return accRig + rig.wells.reduce((accWell, well) => {
        return accWell + well.logs.length;
      }, 0);
    }, 0);
  }, 0);
  


    return (
      <Fragment>
        {

              (totalProviderLogsforAll !== 0 && filteredBusinessUnit.length > 0 )?
              <>
        <table className="tree-view">
          <thead>
            <tr style={getSuperheadeingColor()}><th colSpan={11}><b>Summary</b></th></tr>
            <tr style={getSubeingColor()}>
              <th className='forRight'><b>Business Unit</b></th>
              <th className='forRight' ><b>Rig</b></th>
              <th className='forRight' ><b>Well</b></th>
              <th className='forRight' ><b>Log</b></th>
              <th className='forRight' ><b>Index Type</b></th>
              <th className='forCenter' ><b>Start Index</b></th>
              <th className='forCenter' ><b>End Index</b></th>
              {/* <th><b>Window Length</b></th> */}
              {/* <th><b>Data Provider</b></th> */}
              <th className='forCenter'><b>Log DQI (%)</b></th>
              <th className='forCenter'><b>Well DQI (%)</b></th>
            </tr>
          </thead>
          <tbody>
            {
              

                filteredBusinessUnit.map(provider => {
                  let totalProviderLogs = provider.rigs.reduce((acc, rig) => {
                    return acc + rig.wells.reduce((accWell, well) => {
                      return accWell + well.logs.length;
                    }, 0);
                  }, 0);

                  return provider.rigs.map((rig, rigIndex) => {
                    let totalRigLogs = rig.wells.reduce((acc, well) => acc + well.logs.length, 0);
                    return rig.wells.map((well, wellIndex) => (
                      well.logs.map((log, logIndex) => (
                        <tr key={`${provider.name}-${rig.name}-${well.name}-${log.name}`}>
                          {(rigIndex === 0 && wellIndex === 0 && logIndex === 0) && (
                            <td className='forRight' rowSpan={totalProviderLogs} >{provider.name}</td>
                          )}
                          {(wellIndex === 0 && logIndex === 0) && (
                            <td className='forRight' rowSpan={totalRigLogs} >{rig.name}</td>
                          )}
                          {(logIndex === 0) && <td rowSpan={well.logs.length}>{well.name}</td>}
                          <td className='forRight'>{log.name || "-"}</td>
                          <td className='forRight'>{log.indexType || "-"}</td>
                          <td className='forRight'>{log.indexType === "TIMESERIES" && log.startIndex !== "NOT CALCULATING" ? convertTimeStampToDate(log.startIndex) : log.startIndex || "-"}</td>
                          <td className='forRight'>{log.indexType === "TIMESERIES" && log.endIndex !== "NOT CALCULATING" ? convertTimeStampToDate(log.endIndex) : log.endIndex || "-"}</td>
                          {/* <td>{log.windowLength || "-"}</td> */}
                          {/* <td>{log.dataProvider || "-"}</td> */}
                          <td  className='forCenter' style={getDQIColor(log.logDQIPercentage)}>{log.logDQIPercentage || "-"}</td>
                          {(logIndex === 0) && <td className='forCenter' rowSpan={well.logs.length} style={getDQIColor(well.wellDQIPercentage)}>{well.wellDQIPercentage || "-"}</td>}
                        </tr>
                      ))
                    ))
                  })
                }) }
          </tbody>
        </table>
        <div style={{ width: "100%", paddingRight: "20px" }}>
        <div style={{ marginTop: "35px" }}>
                    <table className="tree-view">
                      <tr >
                        <td style={getSuperheadeingColor()}><b> Detail</b></td>
                      </tr>
                    </table>
                    {/* <table>
                      <tr>
                        <th><b> Rig</b></th>
                        <th><b> Well</b></th>
                        <th><b> Business Unit</b></th>
                      </tr>
                      <tr>
                        <td>{rig className='forCenter' .name}</td>
                        <td>{well.name}</td>
                        <td>{provider.name}</td>
                      </tr>
                    </table> */}
                  </div>
          {filteredBusinessUnit.map(provider => (
            provider.rigs.map(rig => (
              rig.wells.map(well => (
                <div key={`${provider.name}-${rig.name}-${well.name}`} >
                 
                  {well.logs.map((log, index) => (
                    <div key={`${provider.name}-${rig.name}-${well.name}-${log.name}`}>
                      {/* Section for Log */}
                      {log?.mnemonics[0]?.name && (
                        // <table>
                        //   <tr>
                        //     <td>
                        //       <b>Log: {log.name}</b>
                        //     </td>
                        //   </tr>
                        // </table>
                        <table className="tree-view">
                        <tr style={getSupersubeingColor()}>
                          <th className='forRight' ><b>Business Unit</b></th>
                          <th className='forRight' ><b>Rig</b></th>
                          <th className='forRight' ><b>Well</b></th>
                          <th className='forRight' ><b>Data Source</b></th>
                          <th className='forRight' ><b>DQI</b></th>
                         
                        </tr>
                        <tr>
                          <td className='forRight'>{provider.name}</td>
                          <td className='forRight'>{rig.name}</td>
                          <td className='forRight'>{well.name}</td>
                          <td className='forRight'>{log.name}</td>
                          <td className='forRight' style={getDQIColor(log.logDQIPercentage)}>{log.logDQIPercentage}</td>
                        </tr>
                      </table>
                      )}
                      {log?.mnemonics[0]?.name && (
                        <Fragment>
                          <table className="mnemonics-view">
                            <thead>
                              <tr style={getSubeingColor()}>                              
                                <th className='forCenter'><b>Channel</b></th>
                                <th className='forCenter'><b>DQI</b></th>
                                <th className='forCenter'><b>UoM</b></th>
                                {/* <th className='forCenter'><b>Permissible Trouble Occurrences</b></th>
                                <th className='forCenter'><b>Trouble Threshold</b></th> */}
                                <th className='forCenter'><b>Expected Max Value</b></th>
                                <th className='forCenter'><b>Expected Min Value</b></th>
                                <th className='forCenter'><b>Frequency Interval</b></th>
                                <th className='forCenter'><b>Required Precision</b></th>
                                <th className='forCenter'><b>Allowed Data Gap</b></th>
                                <th className='forCenter'><b>Allowed Staleness</b></th>
                                {/* <th className='forCenter'><b>Max Value DQI</b></th>
                                <th className='forCenter'><b>Min Value DQI</b></th>
                                <th className='forCenter'><b>Frequency DQI</b></th>
                                <th className='forCenter'><b>Precision DQI</b></th>
                                <th className='forCenter'><b>Data Gap DQI</b></th>
                                <th className='forCenter'><b>Staleness DQI</b></th>
                                <th className='forCenter'><b>DataCount DQI</b></th>
                                <th className='forCenter'><b>Latency DQI</b></th> */}

                              </tr>
                            </thead>
                            <tbody>
                              {log.mnemonics.map(mnemonic => (
                                <tr key={`${provider.name}-${rig.name}-${well.name}-${log.name}-${mnemonic.name}`}>
                                  {/* <td className='forRight' ><b>{mnemonic.name === "" ? "-" : mnemonic.name === 0 ? 0 : mnemonic.name}</b></td>
                                  <td className='forCenter'  style={getDQIColor(mnemonic?.aspects?.[0].Channel_DQI)}>{mnemonic?.aspects?.[0].Channel_DQI === "" ? "-" : mnemonic?.aspects?.[0].Channel_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Channel_DQI}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].UoM === "" ? "-" : mnemonic?.aspects?.[0].UoM === 0 ? 0 : mnemonic?.aspects?.[0].UoM}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === "" ? "-" : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === 0 ? 0 : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Trouble_Time_Threshold === "" ? "-" : mnemonic?.aspects?.[0].Trouble_Time_Threshold === 0 ? 0 : mnemonic?.aspects?.[0].Trouble_Time_Threshold}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Expected_Max_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Max_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Max_Value}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Expected_Min_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Min_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Min_Value}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Expected_Interval === "" ? "-" : mnemonic?.aspects?.[0].Expected_Interval === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Interval}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Required_Precision === "" ? "-" : mnemonic?.aspects?.[0].Required_Precision === 0 ? 0 : mnemonic?.aspects?.[0].Required_Precision}</td>
                                  <td className='forRight' >{mnemonic?.aspects?.[0].Allowed_Data_Gap === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Data_Gap === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Data_Gap}</td>
                                  <td className='forRight' >{mnemonic?.aspects?.[0].Allowed_Staleness === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Staleness === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Staleness}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Max_value_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Max_value_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Max_value_Weightage}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Min_value_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Min_value_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Min_value_Weightage}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Frequency_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Frequency_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Frequency_Weightage}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Precision_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Precision_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Precision_Weightage}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Data_gap_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Data_gap_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Data_gap_Weightage}</td>
                                  <td className='forCenter' >{mnemonic?.aspects?.[0].Stale_value_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Stale_value_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Stale_value_Weightage}</td>
                                  */}

                                  <td className='forRight'><b>{truncateText(mnemonic.name === "" ? "-" : mnemonic.name === 0 ? 0 : mnemonic.name)}</b></td>
                                  <td className='forCenter'style={getDQIColor(mnemonic?.aspects?.[0].Channel_DQI)}>{truncateText(mnemonic?.aspects?.[0].Channel_DQI === undefined || mnemonic?.aspects?.[0].Channel_DQI === "" ? "-" : mnemonic?.aspects?.[0].Channel_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Channel_DQI)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].UoM === "" ? "-" : mnemonic?.aspects?.[0].UoM === 0 ? 0 : mnemonic?.aspects?.[0].UoM)}</td>
                                  {/* <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === "" ? "-" : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === 0 ? 0 : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Trouble_Time_Threshold === "" ? "-" : mnemonic?.aspects?.[0].Trouble_Time_Threshold === 0 ? 0 : mnemonic?.aspects?.[0].Trouble_Time_Threshold)}</td> */}
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Max_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Max_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Max_Value)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Min_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Min_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Min_Value)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Interval === "" ? "-" : mnemonic?.aspects?.[0].Expected_Interval === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Interval)}</td>
                                  <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Required_Precision === "" ? "-" : mnemonic?.aspects?.[0].Required_Precision === 0 ? 0 : mnemonic?.aspects?.[0].Required_Precision)}</td>
                                  <td className='forRight'>{truncateText(mnemonic?.aspects?.[0].Allowed_Data_Gap === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Data_Gap === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Data_Gap)}</td>
                                  <td className='forRight'>{truncateText(mnemonic?.aspects?.[0].Allowed_Staleness === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Staleness === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Staleness)}</td>
                                  {/* <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Max_value_DQI)}>{truncateText(mnemonic?.aspects?.[0].Max_value_DQI === "" ? "-" : mnemonic?.aspects?.[0].Max_value_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Max_value_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Min_value_DQI)}>{truncateText(mnemonic?.aspects?.[0].Min_value_DQI === "" ? "-" : mnemonic?.aspects?.[0].Min_value_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Min_value_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Frequency_DQI)}>{truncateText(mnemonic?.aspects?.[0].Frequency_DQI === "" ? "-" : mnemonic?.aspects?.[0].Frequency_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Frequency_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Precision_DQI)}>{truncateText(mnemonic?.aspects?.[0].Precision_DQI === "" ? "-" : mnemonic?.aspects?.[0].Precision_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Precision_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Data_gap_DQI)}>{truncateText(mnemonic?.aspects?.[0].Data_gap_DQI === "" ? "-" : mnemonic?.aspects?.[0].Data_gap_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Data_gap_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Staleness_DQI)}>{truncateText(mnemonic?.aspects?.[0].Staleness_DQI === "" ? "-" : mnemonic?.aspects?.[0].Staleness_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Staleness_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].DataCount_DQI)}>{truncateText(mnemonic?.aspects?.[0].DataCount_DQI === "" ? "-" : mnemonic?.aspects?.[0].DataCount_DQI === 0 ? 0 : mnemonic?.aspects?.[0].DataCount_DQI)}</td>
                                  <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Latency_DQI)}>{truncateText(mnemonic?.aspects?.[0].Latency_DQI === "" ? "-" : mnemonic?.aspects?.[0].Latency_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Latency_DQI)}</td> */}
                                 
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {log?.mnemonics[0]?.aspects[0].data[0] && (
                            <div style={{ marginTop: "10px", marginBottom: "35px" }}><b style={{color:"#1991bf"}}>Data Quality History</b>

                              <table className="tree-view">

                                <thead>
                                  <tr>
                                    <th className='forCenter' colSpan={2} style={{backgroundColor:"rgb(163, 162, 162)", color:"white"}}><b>Mnemonic</b></th>
                                    {log.mnemonics.map(mnemonic => (
                                      <th className='forCenter' style={{backgroundColor:"rgb(163, 162, 162)", color:"white"}}><b>{mnemonic.name === "" ? "-" : mnemonic.name === 0 ? 0 : mnemonic.name}</b></th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className='forCenter' colSpan={2}><b>Channel DQI</b></td>
                                    {log.mnemonics.map(mnemonic => (
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Channel_DQI)}>{mnemonic?.aspects?.[0].Channel_DQI === "" ? "-" : mnemonic?.aspects?.[0].Channel_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Channel_DQI}</td>
                                    ))}
                                  </tr>
                                  <tr>
                                    <td className='forCenter'><b>Start Index</b></td>
                                    <td className='forCenter'><b>End Index</b></td>
                                    <td colSpan={log?.mnemonics.length}></td>
                                  </tr>
                                 
                                  {log.indexType === "TIMESERIES" ?
                                    log?.mnemonics[index]?.aspects[0]?.data?.map((data, index) => (
                                      <tr key={index}>
                                        <td className='forCenter'>{convertTimeStampToDate(data.Start_Index)}</td>
                                        <td className='forCenter'>{convertTimeStampToDate(data.End_Index)}</td>
                                        {log?.mnemonics?.map((mnemonic, mnemonicIndex) => (
                                          <td className='forCenter' key={`${index}-${mnemonicIndex}`}>
                                            {mnemonic?.aspects[0]?.data[index]?.Result}
                                          </td>
                                        ))}
                                      </tr>
                                    )) : log?.mnemonics[index]?.aspects[0]?.data?.map((data, index) => (
                                      <tr key={index}>
                                        <td className='forCenter'>{data.Start_Index}</td>
                                        <td className='forCenter'>{data.End_Index}</td>
                                        {log?.mnemonics?.map((mnemonic, mnemonicIndex) => (
                                          <td className='forCenter' key={`${index}-${mnemonicIndex}`}>
                                            {mnemonic?.aspects[0]?.data[index]?.Result}
                                          </td>
                                        ))}
                                      </tr>
                                    ))
                                  }
                                </tbody>
                              </table>
                            </div>
                          )}
                        </Fragment>
                      )}
                    </div>
                  ))}
                </div>
              ))
            ))
          ))}
        </div></>
        : <p style={{ textAlign: "center", fontWeight:"700" }}>Detailed Data not Found</p>}
      </Fragment>
    );
  }
  else {
    return "No Detailed Data Found";
  }
}
export default DQI_Detailed;